import { render, staticRenderFns } from "./getTraceCode.vue?vue&type=template&id=3f3880b6&scoped=true"
import script from "./getTraceCode.vue?vue&type=script&lang=js"
export * from "./getTraceCode.vue?vue&type=script&lang=js"
import style0 from "./getTraceCode.vue?vue&type=style&index=0&id=3f3880b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3880b6",
  null
  
)

export default component.exports